export default "__VITE_ASSET__2gFbNwm0__"